import React, { useEffect, useState } from "react";
import { Link, Navigate } from "react-router-dom";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";
import ProjectCard from "../components/ProjectCard";

export default function Dashboard({ onOpenAuth }) {
  const { user, loading } = useAuth();
  const [items, setItems] = useState([]);
  const [busy, setBusy] = useState(true);

  useEffect(() => {
    if (!user) return;
    setBusy(true);
    api.get("/me/votes").then(({ data }) => setItems(data)).finally(() => setBusy(false));
  }, [user]);

  if (loading) return <div className="container-civic py-16">Se încarcă…</div>;
  if (!user) return <Navigate to="/" replace />;

  const onVoteChange = (updated) => {
    setItems((arr) => {
      // if user removed their vote, drop from list
      const found = arr.find((p) => p.project_id === updated.project_id);
      if (updated.user_vote === null || updated.user_vote === undefined) {
        return arr.filter((p) => p.project_id !== updated.project_id);
      }
      return found
        ? arr.map((p) => (p.project_id === updated.project_id ? updated : p))
        : [...arr, updated];
    });
  };

  return (
    <main className="container-civic py-12 md:py-16">
      <div className="label-overline">Profilul tău</div>
      <h1 className="font-display text-4xl md:text-5xl font-black tracking-tight mt-3">Voturile mele</h1>
      <p className="mt-3 text-sm text-foreground/70 max-w-xl">
        Toate proiectele pentru care ai votat. Îți poți schimba votul oricând.
      </p>

      <div className="mt-10">
        {busy ? (
          <p className="text-foreground/60">Se încarcă…</p>
        ) : items.length === 0 ? (
          <div className="card-flat p-12 text-center">
            <p className="text-foreground/70">Nu ai votat încă niciun proiect.</p>
            <Link to="/proiecte" className="btn-primary mt-5 inline-flex" data-testid="goto-projects-btn">
              Descoperă proiecte
            </Link>
          </div>
        ) : (
          <div className="grid sm:grid-cols-2 gap-6">
            {items.map((p) => (
              <ProjectCard
                key={p.project_id}
                project={p}
                onVoteChange={onVoteChange}
                requestLogin={() => onOpenAuth?.("login")}
              />
            ))}
          </div>
        )}
      </div>
    </main>
  );
}
